import { formatMoney, formatQty } from '../../lib/format.js'

// ReorderRow — one below-par item in the cross-unit consolidated reorder
// list (Ship 6). Shows the unit chip (color keyed by unit ordering, the
// same UNIT_COLORS ramp the group overlays use), the item name, on-hand /
// par, lead time, urgency, and the restock cost. A red "Critical" badge
// renders when the item is out of stock with a short lead time.
//
// The unit chip color is passed IN (the parent owns the by-unit color map
// so colors stay consistent across the whole list and the filter chips).

export default function ReorderRow({ item, unitColor }) {
  const {
    restaurant_name,
    item_name,
    current_on_hand,
    par_qty,
    lead_time_days,
    urgency,
    restock_cost,
    critical,
  } = item

  return (
    <li className="flex items-center gap-3 border-b border-black/5 px-4 py-3 last:border-b-0">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <UnitChip name={restaurant_name} color={unitColor} />
          {critical && (
            <span className="inline-flex shrink-0 items-center rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-700">
              Critical
            </span>
          )}
        </div>
        <div className="mt-1 truncate text-sm font-medium text-black/85">{item_name}</div>
        <div className="mt-0.5 text-xs text-black/55">
          {formatQty(current_on_hand)} on hand / {formatQty(par_qty)} par
          <span className="mx-1.5 text-black/25">·</span>
          {lead_time_days}-day lead
          <span className="mx-1.5 text-black/25">·</span>
          urgency {formatUrgency(urgency)}
        </div>
      </div>
      <div className="shrink-0 text-right">
        <div className="text-sm font-semibold text-black/85">{formatMoney(restock_cost)}</div>
        <div className="text-[10px] uppercase tracking-wide text-black/45">restock</div>
      </div>
    </li>
  )
}

function UnitChip({ name, color }) {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium"
      style={
        color
          ? { backgroundColor: color.bg, color: color.text, borderColor: 'transparent' }
          : { backgroundColor: '#f3f4f6', color: '#374151', borderColor: 'transparent' }
      }
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: color?.dot || '#6b7280' }}
        aria-hidden="true"
      />
      <span className="max-w-[10rem] truncate">{name}</span>
    </span>
  )
}

// Urgency is an internal score; show one decimal, trimming a trailing .0.
function formatUrgency(n) {
  const v = Number(n)
  if (!Number.isFinite(v)) return '0'
  return Number(v.toFixed(1)).toString()
}
